import {useCallback} from 'react'
import {useSearchParams} from '@github-ui/use-navigate'
import {isNoRepoSelection} from '@github-ui/repos-selector'

const REPO_FILTER_PARAM = 'repo_filter'

/** Sentinel value for the repo filter indicating tasks with no associated repository. */
export const NO_REPO_FILTER = 'none'

interface RepoTasksFilter {
  /** Current filter: `undefined` (all repos), `"none"` (no repo), or a NWO string. */
  repoFilter: string | undefined
  /** Update the filter from a ReposSelector selection. */
  setRepoFilter: (repo: {nameWithOwner: string} | undefined) => void
}

/**
 * Manages repository filter state for the agents page, backed by URL search params.
 */
export function useRepoTasksFilter(): RepoTasksFilter {
  const [searchParams, setSearchParams] = useSearchParams()

  const repoFilterParam = searchParams.get(REPO_FILTER_PARAM)
  const repoFilter = repoFilterParam || undefined

  const setRepoFilter = useCallback(
    (repo: {nameWithOwner: string} | undefined) => {
      if (repo && isNoRepoSelection(repo)) {
        searchParams.set(REPO_FILTER_PARAM, NO_REPO_FILTER)
      } else if (repo) {
        searchParams.set(REPO_FILTER_PARAM, repo.nameWithOwner)
      } else {
        searchParams.delete(REPO_FILTER_PARAM)
      }
      searchParams.delete('page')
      setSearchParams(searchParams)
    },
    [searchParams, setSearchParams],
  )

  return {repoFilter, setRepoFilter}
}
